import React, { createContext, useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, RecaptchaVerifier } from 'firebase/auth';
import requests from '../utils/requests.js';

export const PersonContext = createContext();

const Person = ({ children, isapp }) => {
    const [user, setUser] = useState(null);
    const [person, setPerson] = useState(null);
    const [authorizing, setAuthorizing] = useState(true);
    const [appVerifier, setAppVerifier] = useState(null);

    const [cart, setCartState] = useState(null);
    const setCart = async (cart) => {
        setCartState(cart);
        await requests.updatePerson(auth, { cart });
        console.log({ cart });
    }
    useEffect(() => {
        setCartState(person?.cart);
    }, [person]);

    const app = initializeApp({
        apiKey: "AIzaSyDzRJNwlVSmLpiwkpF2BdgGCA_ekqrUkn8",
        authDomain: "versatile-express.firebaseapp.com",
        projectId: "versatile-express",
        storageBucket: "versatile-express.appspot.com",
        messagingSenderId: "273513971139",
        appId: "1:273513971139:web:ea6e209c4f34c2c7bd5176",
        measurementId: "G-7LZWJH4MRN"
    });
    const auth = getAuth(app);

    useEffect(() => {
        setAppVerifier(new RecaptchaVerifier(auth, 'recaptcha-container', { size: 'invisible', callback: () => { } }));
        onAuthStateChanged(auth, async user => {
            setUser(user);
            if (user) {
                let person = await requests.getMe(auth);
                setAuthorizing(false);
                setPerson(person);
            } else {
                setAuthorizing(false);
                setPerson(false);
            }
        });
    }, []);






    const [newNotifications, setNewNotifications] = useState(false);
    const [silentNotifications, setSilentNotifications] = useState(false);
    const db = getFirestore(app);
    useEffect(() => {
        if (authorizing || !person) return;
        const unsubscribe = onSnapshot(collection(db, `people/${person.id}/notifications`), snapshot => {
            snapshot.docChanges().forEach(change => {
                if (change.type === "added") {
                    console.log("New Notification", change.doc.data());
                    requests.deletePersonNotification(auth, change.doc.id);
                    if (!change.doc.data().silent) {
                        setNewNotifications(true);
                    } else {
                        setSilentNotifications(true);
                    }
                }
            });
        });
        return () => unsubscribe();
    }, [person, authorizing]);

    const [orders, setOrders] = useState([]);
    const [gettingOrders, setGettingOrders] = useState(false);
    useEffect(() => {
        if (authorizing || !person) return;
        console.log("normal notifications");
        if (newNotifications) {
            setNewNotifications(false);
        }
        setGettingOrders(true);
        requests.getMyOrders(auth).then(orders => {
            setGettingOrders(false);
            setOrders(orders);
        });
    }, [person, authorizing, newNotifications]);
    
    useEffect(() => {
        if (authorizing || !person) return;
        console.log("silent notifications");
        setSilentNotifications(false);
        requests.getMyOrders(auth).then(orders => {
            setOrders(orders);
        });
    }, [silentNotifications]);

    return (
        <PersonContext.Provider value={{ setPerson, isapp, silentNotifications, newNotifications, app, orders, setGettingOrders, gettingOrders, cart, setCart, authorizing, auth, user, setUser, person, appVerifier }}>
            {children}
            <div id="recaptcha-container"></div>
        </PersonContext.Provider>
    );
}
export default Person;